export const meta = {
  id: 'G02',
  slug: 'primeiro-acesso',
  title: 'Como fazer seu primeiro acesso',
  description: 'Ative seu acesso ao Personagrama a partir do convite recebido.',
  profile: 'student',
  category: 'acesso',
  type: 'task',
  status: 'published',
  order: 20,
  keywords: ['primeiro acesso', 'convite', 'ativar conta', 'entrar', 'cadastro'],
  previous: 'A00',
  next: 'G01',
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como fazer seu primeiro acesso

Seu primeiro acesso começa pelo convite enviado para você. Esse convite conecta sua conta ao ambiente correto do Personagrama.

## Como fazer

<Steps>
  <Step title="Abra o convite recebido">
    Utilize o convite mais recente enviado para seu e-mail ou pelo canal informado pela sua organização.
  </Step>
  <Step title="Acesse o link de ativação">
    O link abre o fluxo de primeiro acesso do Personagrama.
  </Step>
  <Step title="Conclua a configuração solicitada">
    Preencha os dados apresentados na tela e conclua a ativação.
  </Step>
  <Step title="Entre no Personagrama">
    Depois da ativação, utilize suas credenciais para acessar a plataforma.
  </Step>
</Steps>

<HelpImage alt="Tela de primeiro acesso do Personagrama" pendingId="G02.1" />

## Se o convite não funcionar

Se o link estiver inválido ou expirado, use o convite mais recente ou solicite um novo convite ao responsável pelo seu acesso.

<Callout type="important">
  Não compartilhe seu convite, senha ou credenciais de acesso com outras pessoas.
</Callout>

## O que acontece depois

Depois que sua conta estiver ativa, você poderá fazer login e seguir para a tela **Hoje**, que orientará sua próxima ação.
